export const generateSignedPostPayload = <T extends Record<string, string | Blob>>(params: T) => {
  const formData = new FormData();

  Object.keys(params).forEach((paramKey) => {
    formData.append(paramKey, params[paramKey]);
  });

  return formData;
};
